'use strict';

var _storage = require('./client/services/storage');

var _storage2 = _interopRequireDefault(_storage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = require('./config.js'); /* eslint-disable */


var isFromLanding = window.isLanding;
var parentDocument = global.document;
var domain = '.' + window.location.host.split('.').slice(-2).join('.');
var STYLES_HOST = config.stylesHost || 'https://static-ak.pdffiller.com';
var inited = false;
var statInfo = {};

var signnowStylesVersion = '447';
var pdffillerStylesVersion = '461';
var pdffillerStylesLink = STYLES_HOST + '/static/support-static/' + pdffillerStylesVersion + '/organisations/pdffiller/stylesheet/chat/chat.min.css';
var signnowStylesLink = STYLES_HOST + '/static/support-static/' + signnowStylesVersion + '/organisations/signnow/stylesheet/chat/chat_v2.min.css';

var savedOptions = {};

var getCookie = function getCookie(name) {
  if (savedOptions && savedOptions.company && +savedOptions.company !== 2) return undefined;
  // eslint-disable-next-line
  var nameRegex = /([\.$?*|{}\(\)\[\]\\\/\+^])/g;
  var cookieRegex = new RegExp('(?:^|; )' + name.replace(nameRegex, '\\$1') + '=([^;]*)');
  var matches = parentDocument.cookie.match(cookieRegex);

  return matches ? decodeURIComponent(matches[1]) : undefined;
};

var setCookie = function setCookie(key, value, option) {
  if (savedOptions && savedOptions.company && +savedOptions.company !== 2) return;

  var options = {
    path: '/',
    domain: domain
  };

  Object.assign(options, option);

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  var updatedCookie = key + '=' + value;

  for (var optionKey in options) {
    updatedCookie += '; ' + optionKey;
    var optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += '= ' + optionValue;
    }
  }
  document.cookie = updatedCookie;
};

var removeCookie = function removeCookie(key) {
  if (Array.isArray(key)) {
    key.forEach(function (el) {
      setCookie(el, '', { expires: 'Thu, 01 Jan 1970 00:00:01 GMT' });
    });
  } else {
    setCookie(key, '', { expires: 'Thu, 01 Jan 1970 00:00:01 GMT' });
  }
};

var chatStateListener = function chatStateListener() {};
var chatEventListener = function chatEventListener() {};
var closeListenerExists = false;

var appLoaded = false;
var browser = '';
var OS = '';

var scriptUrl = config.scriptUrl || '/js';
var errorsUrl = config.errorsUrl;


function resetChatState(withScriptElem) {
  appLoaded = false;
  browser = '';
  OS = '';
  inited = false;

  if (withScriptElem) {
    var script = document.querySelector('script[src="' + scriptUrl + '"]');
    if (script) {
      script.parentNode.removeChild(script);
    }
  }
}

var identifyOs = function identifyOs() {
  if (navigator.appVersion.indexOf('Win') !== -1) return 'Windows';
  if (navigator.appVersion.indexOf('Mac') !== -1) return 'MacOS';
  if (navigator.appVersion.indexOf('UNIX') !== -1) return 'UNIX';
  if (navigator.appVersion.indexOf('Linux') !== -1) return 'Linux';
  return 'Undefined';
};

var getOs = function getOs() {
  if (OS) return OS;
  OS = identifyOs();
  return OS;
};

var getBrowser = function getBrowser() {
  if (browser) return browser;

  var ua = navigator.userAgent;
  var item = void 0;
  var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

  if (/trident/i.test(M[1])) {
    item = /\brv[ :]+(\d+)/g.exec(ua) || [];
    browser = 'IE ' + (item[1] || '');
    return browser;
  }
  if (M[1] === 'Chrome') {
    item = ua.match(/\b(OPR|Edge)\/(\d+)/);
    if (item !== null) {
      browser = item.slice(1).join(' ').replace('OPR', 'Opera');
      return browser;
    }
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
  if ((item = ua.match(/version\/(\d+)/i)) !== null) {
    M.splice(1, 1, item[1]);
  }
  browser = M.join(' ');
  return browser;
};

var sendError = function sendError(type, details) {
  var xhr = new XMLHttpRequest();

  var body = 'browser=' + encodeURIComponent(getBrowser()) + '\n    &os=' + encodeURIComponent(getOs()) + '\n    &details=' + encodeURIComponent(details || '') + '\n    &type=' + encodeURIComponent(type);

  xhr.open('POST', errorsUrl, true);
  xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
  xhr.send(body);
};

var injectScript = function injectScript(src) {
  return new Promise(function (resolve, reject) {
    var wasScriptLoaded = parentDocument.querySelector('script[src="' + src + '"]');

    if (wasScriptLoaded) {
      resolve();
    }

    var script = parentDocument.createElement('script');
    script.async = true;
    script.src = src;
    if (src.match(/(app.js)/) && savedOptions.company === 2) {
      script.defer = true;
      script.async = false;
    }
    script.addEventListener('load', resolve);
    script.addEventListener('error', function () {
      sendError('error_inject_js ' + src);
      reject('Error loading script.');
    });
    script.addEventListener('abort', function () {
      sendError('abort_inject_js ' + src);
      reject('Script loading aborted.');
    });
    parentDocument.head.appendChild(script);
  });
};

function injectLink(href) {
  var link = parentDocument.createElement('link');
  link.href = href;
  link.rel = 'stylesheet';

  if (parentDocument.head) {
    parentDocument.head.appendChild(link);
  } else {
    parentDocument.head = parentDocument.createElement('head');
    parentDocument.head.appendChild(link);
  }
}

var triggerEvent = function triggerEvent(el, eventName) {
  var event = void 0;
  if (parentDocument.createEvent) {
    event = parentDocument.createEvent('HTMLEvents');
    event.initEvent(eventName, true, true);
  } else if (parentDocument.createEventObject) {
    // IE < 9
    event = parentDocument.createEventObject();
    event.eventType = eventName;
  }
  event.eventName = eventName;
  if (el.dispatchEvent) {
    el.dispatchEvent(event);
  } else if (el.fireEvent && htmlEvents['on' + eventName]) {
    // IE < 9
    el.fireEvent('on' + event.eventType, event); // can trigger only real event (e.g. 'click')
  } else if (el[eventName]) {
    el[eventName]();
  } else if (el['on' + eventName]) {
    el['on' + eventName]();
  }
};

var dispatchOpenChat = function dispatchOpenChat() {
  var chatDomEl = parentDocument.getElementById('chat-app-wrapper');

  if (!closeListenerExists) {
    chatDomEl.addEventListener('close-chat', function () {
      chatStateListener(false);
      chatEventListener('close-chat');
    });

    chatDomEl.addEventListener('container-loaded', function (_ref) {
      var eventData = _ref.eventData;

      chatEventListener('container-loaded', eventData);
    });

    chatDomEl.addEventListener('staff-message', function (_ref2) {
      var eventData = _ref2.eventData;

      chatEventListener('staff-message', eventData);
    });
  }

  closeListenerExists = true;

  if (!chatDomEl) {
    sendError('error_in_app.js 1');
    return false;
  }
  triggerEvent(chatDomEl, 'open-chat');
  chatEventListener('open-chat');
  setTimeout(function () {
    if (!getCookie('chat-app-success') || !_storage2.default.get('chat-app-success')) {
      return sendError('error_in_app.js 2');
    }
    _storage2.default.remove('chat-app-success');
    removeCookie('chat-app-success');
  }, 2000);
  return true;
};

var handlerLoadScript = function handlerLoadScript(status) {
  if (status !== 200) {
    appLoaded = false;
    sendError('get_app.js');
    return appLoaded;
  }
  appLoaded = true;
  dispatchOpenChat();
  return appLoaded;
};

var injectAppScript = function injectAppScript() {
  var _savedOptions = savedOptions,
      company = _savedOptions.company;

  if (company === 2) {
    injectLink(signnowStylesLink);
  } else {
    injectLink(pdffillerStylesLink);
  }

  return injectScript(scriptUrl).then(function () {
    handlerLoadScript(200);
  }).catch(function () {
    handlerLoadScript(404);
  });
};

var initChatNew = function initChatNew() {
  var _savedOptions2 = savedOptions,
      company = _savedOptions2.company;

  if (company === 2) {
    injectLink(signnowStylesLink);
  } else {
    injectLink(pdffillerStylesLink);
  }

  injectAppScript();
};

var setUserInStorage = function setUserInStorage(user) {
  if (user && user.id) {
    setCookie('chat-app-user-support-id', user.id);
    _storage2.default.set('chat-app-user-support-id', user.id);
  } else {
    removeCookie('chat-app-user-support-id');
    _storage2.default.remove('chat-app-user-support-id');
  }

  if (user && (user.email || user.primaryEmail)) {
    setCookie('chat-app-user-support-email', user.email || user.primaryEmail);
    _storage2.default.set('chat-app-user-support-email', user.email || user.primaryEmail);
  } else {
    removeCookie('chat-app-user-support-email');
    _storage2.default.remove('chat-app-user-support-email');
  }

  if (user && user.token) {
    setCookie('chat-app-user-support-token', user.token);
    _storage2.default.set('chat-app-user-support-token', user.token);
  } else {
    removeCookie('chat-app-user-support-token');
    _storage2.default.remove('chat-app-user-support-token');
  }
};

function reduce(arr, method, initValue) {
  var currValue = initValue;
  for (var i = 0; i < arr.length; i++) {
    currValue = method(currValue, arr[i]);
  }

  return currValue;
}

function data2Query(obj, withEncode) {
  function reduceMethod(acc, key) {
    var value = obj[key];
    return acc.concat(key + '=' + (withEncode ? encodeURIComponent(value) : value));
  }

  return reduce(Object.keys(obj), reduceMethod, []).join('&');
}

var sendRequest = function sendRequest(url) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GET';
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return new Promise(function (res, rej) {
    var xhr = new XMLHttpRequest();

    xhr.open(method, url, true);
    xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
    xhr.send(data2Query(data, true));

    xhr.onreadystatechange = function () {
      if (xhr.readyState === XMLHttpRequest.DONE && xhr.status >= 200 && xhr.status < 300) {
        try {
          res(xhr.response ? JSON.parse(xhr.response) : {});
        } catch (e) {
          rej(new Error('responseError'));
        }
      } else if (xhr.readyState === XMLHttpRequest.DONE) {
        try {
          rej(xhr.response ? JSON.parse(xhr.response) : {});
        } catch (e) {
          rej(e);
        }
      }
    };
  });
};

var startLoad = function startLoad() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
  var obj = arguments[1];

  e && e.preventDefault();

  chatStateListener(true);

  if (obj) {
    if ('category_id' in obj) {
      setCookie('chat-app-initial-info', JSON.stringify(obj));
      _storage2.default.set('chat-app-initial-info', JSON.stringify(obj));
    } else if ('userId' in obj) {
      setCookie('chat-app-user-id', obj.userId);
      _storage2.default.set('chat-app-user-id', obj.userId);
    } else {
      setCookie('chat-app-from', JSON.stringify(obj));
      _storage2.default.set('chat-app-from', JSON.stringify(obj));
    }
  } else {
    removeCookie('chat-app-from');
    _storage2.default.remove('chat-app-from');
  }

  var _savedOptions3 = savedOptions,
      company = _savedOptions3.company,
      user = _savedOptions3.user;


  if (company) {
    setCookie('chat-app-com-type', company);
    _storage2.default.set('chat-app-com-type', company);
  } else {
    removeCookie('chat-app-com-type');
    _storage2.default.remove('chat-app-com-type');
  }

  setUserInStorage(user);

  if (appLoaded && appLoaded === 'pending') return false;

  if (!appLoaded) {
    appLoaded = 'pending';
    initChatNew();
  } else {
    dispatchOpenChat();
  }

  return true;
};

var closeChatApp = function closeChatApp() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$callClose = _ref3.callClose,
      callClose = _ref3$callClose === undefined ? false : _ref3$callClose;

  stopLoad();
  var chatDomEl = parentDocument.getElementById('chat-app-wrapper');
  if (callClose) {
    triggerEvent(chatDomEl, 'call-chat-close');
  } else {
    triggerEvent(chatDomEl, 'close-chat');
  }
};

var initActions = function initActions(options) {
  var company = options.company,
      user = options.user,
      isSignerMode = options.isSignerMode,
      senderInfo = options.senderInfo;


  if (company) {
    setCookie('chat-app-com-type', company);
    _storage2.default.set('chat-app-com-type', company);
  } else {
    removeCookie('chat-app-com-type');
    _storage2.default.remove('chat-app-com-type');
  }

  if (isSignerMode) {
    _storage2.default.set('chat-app-sign-mode', isSignerMode);
  } else {
    _storage2.default.remove('chat-app-sign-mode');
  }

  if (senderInfo) {
    _storage2.default.set('chat-app-sender-info', JSON.stringify(senderInfo) || 0);
  } else {
    _storage2.default.remove('chat-app-sender-info');
  }

  setUserInStorage(user);

  if (typeof window !== 'undefined') {
    initChatNew();

    return true;
  }
  return false;
};

var init = function init(_) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // todo in task remove loader
  inited = true;

  savedOptions = options;

  if (!Promise.finally) {
    Promise.prototype.finally = Promise.prototype.finally || {
      finally: function _finally(fn) {
        var onFinally = function onFinally(callback) {
          return Promise.resolve(fn()).then(callback);
        };
        return this.then(function (result) {
          return onFinally(function () {
            return result;
          });
        }, function (reason) {
          return onFinally(function () {
            return Promise.reject(reason);
          });
        });
      }
    }.finally;
  }

  if (options.company && options.company === 2) {
    return initActions(options);
  }

  initActions(options);
};

var categories = [{
  id: 43,
  name: 'Subscription & billing',
  slug: 'subscription-billing'
}, {
  id: 45,
  name: 'Login & Account Setup',
  slug: 'login-authorization'
}, {
  id: 47,
  name: 'Document Signing & Editing',
  slug: 'document-editing-setup'
}, {
  id: 49,
  name: 'Document saving, printing, faxing, USPS',
  slug: 'document-saving-printing-faxing-usps'
}, {
  id: 50,
  name: 'Document upload and Management',
  slug: 'document-management'
}, {
  id: 51,
  name: 'API and Integration',
  slug: 'integration'
}, {
  id: 53,
  name: 'Data privacy',
  slug: 'data-privacy'
}, {
  id: 54,
  name: 'Other',
  slug: 'other'
}];

var checkOpenedChat = function checkOpenedChat() {
  var state = getCookie('chat-app-state') || _storage2.default.remove('chat-app-state');

  return state === 'opened';
};

var setChatStateListener = function setChatStateListener() {
  var listener = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  chatStateListener = listener;
};
var setChatEventsListener = function setChatEventsListener() {
  var listener = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
  chatEventListener = listener;
};

var checkChatInit = function checkChatInit() {
  return inited;
};

var setStatInfo = function setStatInfo(statisitInfo) {
  statInfo = statisitInfo;
};

var getStatInfo = function getStatInfo() {
  return statInfo;
};

var getSavedOptions = function getSavedOptions() {
  return savedOptions;
};

module.exports = {
  init: init,
  startLoad: startLoad,
  sendError: sendError,
  closeChatApp: closeChatApp,
  categories: categories,
  resetChatState: resetChatState,
  setUserInStorage: setUserInStorage,
  checkOpenedChat: checkOpenedChat,
  setChatStateListener: setChatStateListener,
  setChatEventsListener: setChatEventsListener,
  checkChatInit: checkChatInit,
  setStatInfo: setStatInfo,
  getStatInfo: getStatInfo,
  getSavedOptions: getSavedOptions
};